'use client'
import React from 'react'
import { useTranslation, Trans } from 'react-i18next'

const Error: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="flex h-screen flex-row items-center justify-center gap-x-64">
      <div className="mb-96">
        <Trans
          i18nKey="underMaintenance"
          components={{
            h1: <h1 className="mt-6 text-8xl text-secondary-300" />,
          }}
        />
        <p className="mt-12 text-grey">{t('tryAgainLater')}</p>
      </div>

      <img src="/static/assets/500.svg" />
    </div>
  )
}

export default Error
